import { useSuspenseQueryGet } from "../../typed-client/hooks/use-suspense-query-get"

export const useRequestableAbsenceShiftTypes = ({
  departmentId,
}: {
  departmentId: number
}) =>
  useSuspenseQueryGet(
    "/api/ShiftType/GetRequestableAbsenceShiftTypesForDepartment",
    { departmentId },
    {
      gcTime: Infinity,
      staleTime: Infinity,
    }
  )
